import { GET_PLANNING_WEEK_DATA } from '@bechtel/client-gql';
import { PersonaType, PlanningWeekStats, UnitOfMeasure } from '@bechtel/types';

const initialWeekStats: PlanningWeekStats = {
  id: '',
  weekNumber: 1,
  startDate: '',
  endDate: '',
  year: 0,
  claimedMilestoneStats: {
    id: '',
    hours: 2000,
    numMilestones: 0,
    quantity: {
      quantity: 2,
      unitOfMeasure: UnitOfMeasure.LINEAR_FEET,
    },
  },
  plannedMilestoneStats: {
    id: '',
    hours: 4000,
    numMilestones: 0,
    quantity: {
      quantity: 4,
      unitOfMeasure: UnitOfMeasure.LINEAR_FEET,
    },
  },
  committedMilestoneStats: {
    id: '',
    hours: 4000,
    numMilestones: 0,
    quantity: {
      quantity: 4,
      unitOfMeasure: UnitOfMeasure.LINEAR_FEET,
    },
  },
  crewCapacityHours: 5000,
  target: {
    id: '',
    hours: 5000,
    numMilestones: 0,
    quantity: {
      quantity: 0,
      unitOfMeasure: UnitOfMeasure.LINEAR_FEET,
    },
  },
};

export const crewMemberWeekStatMock: PlanningWeekStats = {
  id: '',
  weekNumber: 1,
  startDate: '',
  endDate: '',
  year: 0,
  claimedMilestoneStats: {
    id: '',
    hours: 0,
    numMilestones: 0,
    quantity: {
      quantity: 0,
      unitOfMeasure: UnitOfMeasure.LINEAR_FEET,
    },
  },
  plannedMilestoneStats: {
    id: '',
    hours: 0,
    numMilestones: 0,
    quantity: {
      quantity: 0,
      unitOfMeasure: UnitOfMeasure.LINEAR_FEET,
    },
  },
  committedMilestoneStats: {
    id: '',
    hours: 0,
    numMilestones: 0,
    quantity: {
      quantity: 0,
      unitOfMeasure: UnitOfMeasure.LINEAR_FEET,
    },
  },
  crewCapacityHours: 0,
  target: {
    id: '',
    hours: 0,
    numMilestones: 0,
    quantity: {
      quantity: 0,
      unitOfMeasure: UnitOfMeasure.LINEAR_FEET,
    },
  },
};

export const planningWeekCardGenernalForemanData: PlanningWeekStats[] = [
  {
    ...initialWeekStats,
    id: '1',
    weekNumber: 10,
    startDate: '2020-05-04T23:00:00Z',
    endDate: '2020-05-10T23:00:00Z',
    year: 2020,
    crewMember: {
      id: '',
      firstName: 'firstName',
      lastName: 'lastName',
      persona: PersonaType.GENERAL_FOREMAN,
    },
  },
  {
    ...initialWeekStats,
    id: '2',
    weekNumber: 11,
    startDate: '2020-05-11T23:00:00Z',
    endDate: '2020-05-17T23:00:00Z',
    year: 2020,
    crewMember: {
      id: '',
      firstName: 'firstName',
      lastName: 'lastName',
      persona: PersonaType.GENERAL_FOREMAN,
    },
  },
  {
    ...initialWeekStats,
    id: '3',
    weekNumber: 12,
    startDate: '2020-05-18T23:00:00Z',
    endDate: '2020-05-24T23:00:00Z',
    year: 2020,
    crewMember: {
      id: '',
      firstName: 'firstName',
      lastName: 'lastName',
      persona: PersonaType.GENERAL_FOREMAN,
    },
  },
];

const planningWeekCardSuperintendentData = [
  {
    ...initialWeekStats,
    id: '1',
    weekNumber: 10,
    startDate: '2020-05-04T23:00:00Z',
    endDate: '2020-05-10T23:00:00Z',
    year: 2020,
    crewMember: {
      id: '',
      firstName: 'firstName',
      lastName: 'lastName',
      persona: PersonaType.SUPERINTENDENT,
    },
  },

  {
    ...initialWeekStats,
    id: '2',
    weekNumber: 11,
    startDate: '2020-05-11T23:00:00Z',
    endDate: '2020-05-17T23:00:00Z',
    year: 2020,
    crewMember: {
      id: '',
      firstName: 'firstName',
      lastName: 'lastName',
      persona: PersonaType.SUPERINTENDENT,
    },
  },
  {
    ...initialWeekStats,
    id: '3',
    weekNumber: 12,
    startDate: '2020-05-18T23:00:00Z',
    endDate: '2020-05-24T23:00:00Z',
    year: 2020,
    crewMember: {
      id: '',
      firstName: 'firstName',
      lastName: 'lastName',
      persona: PersonaType.SUPERINTENDENT,
    },
  },
];

const planningWeekCardForemanData = [
  {
    ...initialWeekStats,
    id: '1',
    weekNumber: 10,
    startDate: '2020-05-04T23:00:00Z',
    endDate: '2020-05-10T23:00:00Z',
    year: 2020,
    crewMember: {
      id: '',
      firstName: 'firstName',
      lastName: 'lastName',
      persona: PersonaType.FOREMAN,
    },
  },
  {
    ...initialWeekStats,
    id: '2',
    weekNumber: 11,
    startDate: '2020-05-11T23:00:00Z',
    endDate: '2020-05-17T23:00:00Z',
    year: 2020,
    crewMember: {
      id: '',
      firstName: 'firstName',
      lastName: 'lastName',
      persona: PersonaType.FOREMAN,
    },
  },
  {
    ...initialWeekStats,
    id: '3',
    weekNumber: 12,
    startDate: '2020-05-18T23:00:00Z',
    endDate: '2020-05-24T23:00:00Z',
    year: 2020,
    crewMember: {
      id: '',
      firstName: 'firstName',
      lastName: 'lastName',
      persona: PersonaType.FOREMAN,
    },
  },
];

export const planningWeekHeaderSingleCardMock = {
  request: {
    query: GET_PLANNING_WEEK_DATA,
    variables: {
      input: {
        numNextWeeks: 2,
      },
    },
  },
  result: {
    data: {
      planningWeekStats: planningWeekCardGenernalForemanData[0],
    },
  },
};

export const planningWeekHeaderMultiCardMock = {
  request: {
    query: GET_PLANNING_WEEK_DATA,
    variables: {
      input: {
        numNextWeeks: 2,
      },
    },
  },
  result: {
    data: {
      planningWeekStats: planningWeekCardGenernalForemanData,
    },
  },
};

/* three planning week card mock data */
export const planningWeekCardGenernalFormanMock = {
  request: {
    query: GET_PLANNING_WEEK_DATA,
    variables: {
      input: {
        persona: PersonaType.GENERAL_FOREMAN,
        crewMemberId: '8b234c43-fa58-4df5-a4b4-1b59e970fb95',
        numNextWeeks: 2,
      },
    },
  },
  result: {
    data: {
      planningWeekStats: planningWeekCardGenernalForemanData,
    },
  },
};

export const planningWeekCardSuperintendentMock = {
  request: {
    query: GET_PLANNING_WEEK_DATA,
    variables: {
      input: {
        persona: PersonaType.SUPERINTENDENT,
        crewMemberId: 'f6d4b98b-f2a6-4d13-89c0-480ff19971d1',
        numNextWeeks: 2,
      },
    },
  },
  result: {
    data: {
      planningWeekStats: planningWeekCardSuperintendentData,
    },
  },
};

/* single planning week card mock data */
export const singlePlanningWeekCardMock = {
  request: {
    query: GET_PLANNING_WEEK_DATA,
    variables: {
      input: {
        persona: PersonaType.GENERAL_FOREMAN,
        crewMemberId: '8b234c43-fa58-4df5-a4b4-1b59e970fb95',
        numNextWeeks: 2,
      },
    },
  },
  result: {
    data: {
      planningWeekStats: [planningWeekCardGenernalForemanData[0]],
    },
  },
};
export const planningWeekCardFormanMock = {
  request: {
    query: GET_PLANNING_WEEK_DATA,
    variables: {
      input: {
        persona: PersonaType.FOREMAN,
        crewMemberId: 'b67ce5c2-61a9-4280-a28e-d9e6b66de133',
        numNextWeeks: 2,
      },
    },
  },
  result: {
    data: {
      planningWeekStats: planningWeekCardForemanData,
    },
  },
};
export const planningWeekCardDefaultFormanMock = {
  request: {
    query: GET_PLANNING_WEEK_DATA,
    variables: {
      input: {
        persona: PersonaType.FOREMAN,
        crewMemberId: 'b67ce5c2-61a9-4280-a28e-d9e6b66de133',
      },
    },
  },
  result: {
    data: {
      plannedMilestones: planningWeekCardForemanData,
    },
  },
};
